import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";

//Hook para cacheLoader
export const fetchMunicipios = async () => {
  const response = await api.get("/municipios");
  return response.data;
};

// Hook reutilizable con React Query
export const useMunicipios = () => {
  return useQuery({
    queryKey: ["municipios"],
    queryFn: fetchMunicipios,
  });
};
